import React, {
  useCallback,
  forwardRef,
  useEffect,
  useRef,
  useState,
} from 'react'
import './dropdown.css'

const FilterOptionsOptionDropdown = forwardRef((props, ref) => {
  const [showFilterDropdown, setShowFilterDropdown] = useState(false)
  const dropdownRef = useRef(null)
  useEffect(() => {
    document.addEventListener('click', (event) => {
      if (ref?.current?.contains(event?.target)) {
        setShowFilterDropdown(true)
      } else {
        if (dropdownRef?.current?.contains(event?.target)) {
          setShowFilterDropdown(true)
        } else {
          setShowFilterDropdown(false)
        }
      }
    })
    return () => {
      document.removeEventListener('click', () => {})
    }
  }, [ref])
  const changeHandler = useCallback(
    (value) => {
      if (props.isNature) {
        props.onChange(props.isNature, props.index, value)
      } else {
        let temp = [...props.activeFilters]
        const valueIndex = temp.indexOf(value)
        if (valueIndex !== -1) {
          temp.splice(valueIndex, 1)
        } else {
          temp.push(value)
        }
        props.onChange(props.isNature, props.index, temp)
      }
    },
    [props]
  )
  return (
    <>
      {showFilterDropdown && (
        <div className='dropdown' ref={dropdownRef}>
          {props?.data?.map((item) => (
            <div
              onClick={() => {
                changeHandler(item.value)
              }}
              key={item.value}
              className={
                props.isMultiple
                  ? props.activeFilters.indexOf(item.value) !== -1
                    ? 'label active'
                    : 'label'
                  : props.activeFilters === item.value
                    ? 'label active'
                    : 'label'
              }
            >
              {props.isMultiple && (
                <div>
                  {props.activeFilters.indexOf(item.value) !== -1 ? '✔' : ''}
                </div>
              )}
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      )}
    </>
  )
})

FilterOptionsOptionDropdown.displayName = 'FilterOptionsOptionDropdown'
export default FilterOptionsOptionDropdown
